import { FormattedMessage } from 'react-intl';

import MainLayout from 'components/layout/main-layout';
import messages from './messages';
import Styled from './styles';

function Aba() {
  return (
    <MainLayout transparentHeader>
      <Styled.Wrapper>
        <Styled.Header>
          <span>
            <FormattedMessage {...messages.title} />
          </span>
        </Styled.Header>
        <Styled.Subtitle>
          <FormattedMessage {...messages.subTitleFrom} />
        </Styled.Subtitle>
        <Styled.Subtitle>
          <FormattedMessage {...messages.subTitleTo} />
        </Styled.Subtitle>
        <Styled.Text>
          <FormattedMessage {...messages.descriptionOne} />
        </Styled.Text>
        <br />
        <Styled.Text>
          <FormattedMessage {...messages.descriptionTwo} />
        </Styled.Text>
        <br />
        <Styled.Subtitle>
          <FormattedMessage {...messages.descriptionThree} />
        </Styled.Subtitle>
        <Styled.Table>
          <Styled.TableRow>
            <Styled.TableCol />
            <div className="aba-table-col rightCell">
              <div className="aba-table-col-title">
                <FormattedMessage {...messages.richrTitleLLC} />
              </div>
            </div>
          </Styled.TableRow>
          <Styled.TableRow>
            <Styled.TableCol>
              <FormattedMessage {...messages.titleSearchFee} />
            </Styled.TableCol>
            <div className="aba-table-col rightCell">
              <FormattedMessage {...messages.searchFeeValue} />
            </div>
          </Styled.TableRow>
          <Styled.TableRow>
            <Styled.TableCol>
              <FormattedMessage {...messages.closing} />
            </Styled.TableCol>
            <div className="aba-table-col rightCell">
              <FormattedMessage {...messages.closingValue} />
            </div>
          </Styled.TableRow>
          <Styled.TableRow>
            <Styled.TableCol>
              <FormattedMessage
                {...messages.ownerPolicy}
                values={{ rsquo: <>&rsquo;</> }}
              />
            </Styled.TableCol>
            <div className="aba-table-col rightCell">
              <FormattedMessage {...messages.ownerPolicyValue} />
            </div>
          </Styled.TableRow>
          <Styled.TableRow>
            <Styled.TableCol>
              <FormattedMessage {...messages.reIssue} />
              <span className="notice">
                <FormattedMessage
                  {...messages.reIssueNotice}
                  values={{ nbsp: <>&nbsp;</> }}
                />
              </span>
            </Styled.TableCol>
            <div className="aba-table-col rightCell">
              <FormattedMessage {...messages.reIssueValue} />
            </div>
          </Styled.TableRow>
          <Styled.TableRow>
            <Styled.TableCol>
              <FormattedMessage {...messages.mortagePolicy} />
              <span className="notice">
                <FormattedMessage {...messages.mortagePolicyNotice} />
              </span>
            </Styled.TableCol>
            <div className="aba-table-col rightCell">
              <FormattedMessage
                {...messages.mortagePolicyValue}
                values={{ rsquo: <>&rsquo;</> }}
              />
            </div>
          </Styled.TableRow>
          <Styled.TableRow>
            <Styled.TableCol>
              <FormattedMessage {...messages.standardEndorsements} />
              <span className="notice">
                <FormattedMessage {...messages.standardEndorsementsNotice} />
              </span>
            </Styled.TableCol>
            <div className="aba-table-col rightCell">
              <FormattedMessage {...messages.standardEndorsementsValue} />
            </div>
          </Styled.TableRow>
        </Styled.Table>
        <Styled.Insurance>
          <div className="aba-insurance-title">
            <FormattedMessage {...messages.abaInsurance} />
          </div>
          <div className="aba-insurance-text">
            <FormattedMessage {...messages.insuranceDescription} />
          </div>
        </Styled.Insurance>
        <Styled.Text className="bottomText">
          <FormattedMessage {...messages.bottomText} />
        </Styled.Text>
        <Styled.Text className="main-aba-property">
          <FormattedMessage {...messages.property} />
          <div className="aba-line" />
        </Styled.Text>
        <Styled.SellerBuyer>
          <div className="main-aba-seller-buyer-leftCol">
            <div className="main-aba-seller-buyer-col">
              <div className="main-aba-seller-buyer-col-subcol">
                <FormattedMessage {...messages.seller} />
                <div className="aba-line-person" />
              </div>
            </div>
            <div className="main-aba-seller-buyer-col">
              <div className="main-aba-seller-buyer-col-subcol">
                <FormattedMessage {...messages.sellerSign} />
                <div className="aba-line-person" />
              </div>
            </div>
          </div>
          <div className="main-aba-seller-buyer-rightCol">
            <div className="main-aba-seller-buyer-col">
              <div className="main-aba-seller-buyer-col-subcol">
                <FormattedMessage {...messages.date} />
                <div className="aba-line-date" />
              </div>
            </div>
          </div>
        </Styled.SellerBuyer>
      </Styled.Wrapper>
    </MainLayout>
  );
}

export default Aba;
